import { IUserConsentProvider } from '@nimbus-library/features/feature-permission/models/i-user-consent.provider';
import { IPermissionService } from '@nimbus-library/features/feature-permission/services/contracts/i-permission.service';
import { MicrosoftPermission, getGraphPermission } from '@nimbus-library/features/graph/enums/graph-permission.enum';

export class GraphUserConsentProvider implements IUserConsentProvider<MicrosoftPermission> {
  public constructor(private readonly permissionService: IPermissionService) {}

  public grantUserConsent(permissions: MicrosoftPermission[]) {
    return this.permissionService.requestUserConsent(permissions.map((permission) => getGraphPermission(permission)));
  }
}
